import BetTextKeys from '../../components/bet/sportsbook-bet-text-keys';
import SportsbookTextKeys from '../../sportsbook-text-keys';

const ShareBetModalTextKeys = { ...BetTextKeys, ...SportsbookTextKeys };

export default ShareBetModalTextKeys;
